import type { Type } from '.';

export function Nonce(config?: Type.Nonce) {
	return config ?? '';
}
